import { SidebarMenu } from '@/components/ui/sidebar'
import { MessagesButton } from '@/domains/messaging'
import { BellButton } from '@/domains/notifications'

import { ResetDemoButton } from './reset-demo-button'

/** the header utility row shared by both the post-onboarding and onboarding
 * shells. notifications first, then messages, then the demo reset in super
 * scope. single source so the pair stays identical and future header buttons
 * land in one place.
 *
 * desktop only margins line the border up with the main header's bottom
 * border. collapsed flips the sign because the logo button shrinks. the
 * mobile sheet has no header beside it so it keeps the default gap
 */
export function SidebarQuickNav() {
  return (
    <SidebarMenu className='border-t border-sidebar-border pt-1 group-data-[collapsible=icon]:mt-2 group-data-[state=expanded]:-mt-2'>
      <BellButton />
      <MessagesButton />
      <ResetDemoButton />
    </SidebarMenu>
  )
}
